import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "advantages",
  class: "bg-hex-F6F6F6 pt-100px <lg:pt-50px pb-60px <lg:pb-0px <sm:pb-50px"
}
const _hoisted_2 = { class: "flex w-full pl-80px <lg:pl-40px <lg:pb-0 pb-10px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_advantages_advantage_card = _resolveComponent("the-advantages-advantage-card")!
  const _component_accent_button = _resolveComponent("accent-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_central_block = _resolveComponent("central-block")!
  const _component_the_advantages_section_carousel = _resolveComponent("the-advantages-section-carousel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[7] || (_cache[7] = _createElementVNode("div", {
      class: "bg-hex-F6F6F6 mt-50px <xl:mt-0px h-140px <lg:h-100px <sm:h-50px <sm:mt-20px",
      style: {"clip-path":"polygon(0% 100%, 100% 100%, 100% 0%, 0% 100%)"}
    }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_central_block, {
        title: "преимущества",
        image: require('@/assets/img/img_4_step_bg.png'),
        subtitle: "чем мы отличаемся"
      }, {
        centr_content: _withCtx(() => _cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "p-80px pr-10px <lg:pt-60px <lg:pl-40px <800:pt-40px <700:pt-20px text-22px <lg:text-14px <lg:leading-25px leading-35px <sm:p-0 <sm:text-12px <sm:leading-17px" }, " Постоянно работаем над качеством услуг нашего сервиса, прислушиваясь к Вашим реккомендациям, поэтому мы во многом на голову выше наших конкурентов, попробуйте, и убедитесь в этом сами ", -1)
        ])),
        abs_content: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_the_advantages_advantage_card, {
              class: "<1550:hidden w-450px mr-20px",
              title: "высокий доход"
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("нет ограничений по выплатам и уровню заработка, бонусы и поощрения")
              ])),
              _: 1
            }),
            _createVNode(_component_the_advantages_advantage_card, {
              class: "<1550:hidden w-450px",
              title: "Удобство"
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("личный кабинет прост и удобен, оперативная передача информации и отслеживание статуса")
              ])),
              _: 1
            }),
            _createVNode(_component_the_advantages_advantage_card, {
              class: "1550:hidden <sm:hidden <sm:h-100px <700:w-250px",
              title: "Надежность"
            }, {
              default: _withCtx(() => [
                _cache[4] || (_cache[4] = _createTextVNode("мы являемся официальными партнерами банков ")),
                _cache[5] || (_cache[5] = _createElementVNode("br", { class: "<700:hidden" }, null, -1)),
                _cache[6] || (_cache[6] = _createTextVNode("и имеем соотвествующие ")),
                _createVNode(_component_router_link, { to: "/certificates" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_accent_button, { class: "<sm:text-14px" }, {
                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createTextVNode("сертификаты")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["image"]),
      _createVNode(_component_the_advantages_section_carousel, { class: "mt-60px <sm:mt-0" })
    ]),
    _cache[8] || (_cache[8] = _createElementVNode("div", {
      class: "h-150px <lg:h-100px <sm:h-50px w-full bg-hex-F6F6F6",
      style: {"clip-path":"polygon(0% 100%, 100% 0%, 100% 0%, 0% 0%)"}
    }, null, -1))
  ], 64))
}